// src/api.js
import axios from "axios";

import { baseUrl } from '../config/clientsConfig'

const leadSourceService = {
  fetchLeadSources: () => {
    return axios.get(`${baseUrl}/leadSources`);
  },
  addLeadSource: (name) => {
    return axios.post(`${baseUrl}/leadSource`, { name });
  },
  updateLeadSource: (id, name) => {
    return axios.put(`${baseUrl}/leadSource`, { id, name });
  },
  fetchMainData: ()=>{
    return axios.get(`${baseUrl}/lead-source/get-main`)
  },
  createLeadSource : (body)=>{
    return axios.post(`${baseUrl}/lead-source/create`,body)
  },
  getSubLeadSource : (parentNode)=>{
    return axios.get(`${baseUrl}/lead-source/get-sub?parentNode=${parentNode}`)
  },
  editSubLeadSource : (body)=>{
    return axios.put(`${baseUrl}/lead-source/update`,body)
  },
  getLeadSource : (searchKey = "")=>{
    return axios.get(`${baseUrl}/lead-source/search?searchKey=${searchKey}`)
  },
  getAllLeadSource: () => {
    return axios.get(`${baseUrl}/lead-source/get-all`);
  }
};

export default leadSourceService;
